import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileExtension',
    standalone: true
})
export class FileExtensionPipe implements PipeTransform {
    transform(value: string): string {
        return value.split('.').pop() ?? '';
    }
}
